export const bootcamp = {
  utor: {
    data: {
      sourceKey: "src_2hNHAfOKr0h3o9u7DL1UrQoFPuD",
      writeKey: "wk_2hNHAih8xoLPDUFcYzT5qtZkPmG",
    },
    cybersecurity: {
      sourceKey: "src_2hNH50mnLL6mrysLJ4KewXp9K7g",
      writeKey: "wk_2hNH51CrBi8GaZS0Hb7EzExLlCI",
    },
  },
  cu: {
    ai: {
      sourceKey: "src_2hNGfT52tgrvC530PKH3RpVez4s",
      writeKey: "wk_2hNGfYReBoUTbSQ1F5EQjgfeEhD",
    }
  },
  rice: {
    cybersecurity: {
      sourceKey: "src_2gYLUb9GADjLFF0fG5nKxXVsuxq",
      writeKey: "wk_2gYLUYIz6dbIASln4zsiV0cbTRW",
      oneTrust: "01922052-3c19-7b38-be28-9704880ddb68",
      segmentId: "EIK7ad1Q8bA6A4GdItsxWxv3QUy4SSOG",
      gtagId: "GTM-WK6WHF6",
    },
  },
  asu: {
    cybersecurity: {
      sourceKey: "src_2gYKKSqsKhbVUVUJcZfIkdxfjns",
      writeKey: "wk_2gYKKOMakQarZLMD7TYs6axrwXl",
    },
  },
  minn: {
    cybersecurity: {
      sourceKey: "src_2hQ1dU9rhdYAW3qLZv40OAfwi1V",
      writeKey: "wk_2hQ1dUwFTAuNEwGzLknDQZapcAN",
    },
  },
  utsa: {
    cybersecurity: {
      sourceKey: "src_2hQ1hF1c9pvVD8dKg9dSjnKegxS",
      writeKey: "wk_2hQ1hFiqVMknoKRx4LNvRsfctuZ",
    },
  },
};
